
/**
 * 플랫폼 지원
 */
export type CreateCourseDraft201SectionsItemLecturesItemPlatformSupport = typeof CreateCourseDraft201SectionsItemLecturesItemPlatformSupport[keyof typeof CreateCourseDraft201SectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateCourseDraft201SectionsItemLecturesItemPlatformSupport = {
  WEB: 'WEB',
  MOBILE: 'MOBILE',
  DESKTOP: 'DESKTOP',
  ALL: 'ALL',
} as const;
